import React from 'react'

const Container = ({ children, padding = 5, center = true, dark = false, className = '', ...otherProps }) => (
    <div className={`py-${padding} ${center ? 'text-center': ''} ${dark ? 'text-dark' : ''} ${className}`} { ...otherProps }>
        { children }
    </div>
)

export default Container